export const normalizeEmail = (value: string) => value.trim().toLowerCase();
